module.exports = __webpack_public_path__ + "img/17.831dd97d.jpg";